import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import guardianReducer from 'guardian/reducers';

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    guardian: guardianReducer,
  });

export default rootReducer;
